/**
 * The following tables are available
 */
export enum TableName {
    ASSIGNMENTS = 'assignments',
    SETTINGS = 'settings',
    API_QUEUE = 'apiQueue',
    SYNC_DATA = 'syncData',
    SYNC_NOTIFICATION = 'syncNotification',
    DEVIATIONS = 'deviations',
    ROUTES = 'routes',
    OPEN_GATE_COUNTER = 'openGateCounter',
		FEEDBACK = 'feedback',
}